export const FLAG_GETTING_WORKSTATIONS = 'FLAG_GETTING_WORKSTATIONS';
export const GET_WORKSTATIONS = 'GET_WORKSTATIONS';
export const CLEAR_WORKSTATIONS = 'CLEAR_WORKSTATIONS';
export const FLAG_WORKSTATION_ACTIVITY = 'FLAG_WORKSTATION_ACTIVITY';
export const GET_WORKSTATION = 'GET_WORKSTATION';
export const CLEAR_WORKSTATION = 'CLEAR_WORKSTATION';
